module.exports = __webpack_public_path__ + "img/OpenSans-Regular.08bcaca3.svg";